import { ExitPopup } from './exitPopup/exitPopup.component';
import { CommonPopup } from './commonPopup/commonPopup.component';
import { AgeGatePopup } from './ageGatePopup/ageGatePopup.component';
import { GeoBlockPopup } from './geoBlockPopup/geoBlockPopup.component';
import { ProfilesGatePopup } from './profilesGatePopup/profilesGatePopup.component';
import { KidsLeave } from './kidsLeavePopup/kidsLeavePopup.component';
import { ParentalCode } from './parentalCodePopup/parentalCode.component';
import { CSLLockPopup } from './cslLockPopup/cslLockPopup.component';
import { GridPopup } from './gridPopup/gridPopup.component';
import { ContentRatingLockPopup } from './contentRatingLockPopup/contentRatingLockPopup.component';
import { ParentalFilterPopupLock } from './parentalFilterPopupLock/parentalFilterPopupLock.component';
import { MaxParentalCodePopup } from './maxParentalCodePopup/maxParentalCodePopup.component';
import {
  AGE_GATE_POPUP_ID,
  COMMON_POPUP_ID,
  EXIT_POPUP_ID,
  FATAL_ERROR_POPUP_ID,
  GEO_BLOCK_POPUP_ID,
  PROFILES_GATE_POPUP_ID,
  KIDS_LEAVE_POPUP_ID,
  BROADCASTING_LOCK_POPUP_ID,
  FREEMIUM_LOCK_POPUP_ID,
  PARENTAL_CODE_POPUP_ID,
  CSL_BLOCK_POPUP_ID,
  EPG_POPUP_ID,
  EPG_LAYOUT_POPUP_ID,
  GRID_POPUP_ID,
  SUBSCRIPTION_POPUP_ID,
  ACCOUNT_COMPLETION_POPUP_ID,
  CONTENT_RATING_POPUP_ID,
  PARENTAL_FILTER_POPUP_ID,
  MAX_PARENTAL_CODE_POPUP_ID,
} from './popups.constants';
import { BroadcastingLockPopup } from './broadcastingLockPopup/broadcastingLockPopup.component';
import { FreemiumLockPopup } from './freemiumLockPopup/freemiumLockPopup.component';
import { EpgPopup } from '../tornado/templates/blocks/epg/epgPopup/epgPopup.component';
import { SubscriptionPopup } from './subscriptionPopup/subscriptionPopup.component';
import { ProgramCard } from '../tornado/templates/blocks/epg/programCard/programCard.component';
import { AccountCompletionPopup } from './accountCompletionPopup/accountCompletionPopup.component';

export const getPopupByID = id => {
  let popup = {};
  switch (id) {
    case GEO_BLOCK_POPUP_ID:
      popup = {
        type: GeoBlockPopup,
      };
      break;
    case AGE_GATE_POPUP_ID:
      popup = {
        type: AgeGatePopup,
        routeBackOnClose: true,
      };
      break;
    case PROFILES_GATE_POPUP_ID:
      popup = {
        type: ProfilesGatePopup,
      };
      break;
    case KIDS_LEAVE_POPUP_ID:
      popup = {
        type: KidsLeave,
      };
      break;
    case EXIT_POPUP_ID:
      popup = {
        type: ExitPopup,
      };
      break;
    case FATAL_ERROR_POPUP_ID:
      popup = {
        type: CommonPopup,
        routeBackOnClose: true,
        exitAppOnClose: true,
      };
      break;
    case BROADCASTING_LOCK_POPUP_ID:
      popup = {
        type: BroadcastingLockPopup,
      };
      break;
    case FREEMIUM_LOCK_POPUP_ID:
      popup = {
        type: FreemiumLockPopup,
      };
      break;
    case PARENTAL_CODE_POPUP_ID:
      popup = {
        type: ParentalCode,
      };
      break;
    case CSL_BLOCK_POPUP_ID:
      popup = {
        type: CSLLockPopup,
        routeBackOnClose: true,
      };
      break;
    case EPG_POPUP_ID:
      popup = {
        type: EpgPopup,
      };
      break;
    case EPG_LAYOUT_POPUP_ID:
      popup = {
        type: ProgramCard,
      };
      break;
    case GRID_POPUP_ID:
      popup = {
        type: GridPopup,
      };
      break;
    case SUBSCRIPTION_POPUP_ID:
      popup = {
        type: SubscriptionPopup,
      };
      break;
    case ACCOUNT_COMPLETION_POPUP_ID:
      popup = {
        type: AccountCompletionPopup,
      };
      break;
    case CONTENT_RATING_POPUP_ID:
      popup = {
        type: ContentRatingLockPopup,
      };
      break;
    case PARENTAL_FILTER_POPUP_ID:
      popup = {
        type: ParentalFilterPopupLock,
      };
      break;
    case MAX_PARENTAL_CODE_POPUP_ID:
      popup = {
        type: MaxParentalCodePopup,
      };
      break;
    case COMMON_POPUP_ID:
    default:
      popup = {
        type: CommonPopup,
      };
      break;
  }
  popup.popupId = id;

  return popup;
};
